import React from 'react'

const BlastFreezer = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Laboratory Equipments</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Blast Freezer</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/blastfreezer.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>Blast Freezer:</h2>
                        <h4 style={{ textDecoration: "underline" }}>WLS-125BF, WLS-250BF , WLS-450BF , WLS-610BF</h4>
                        <p className="mbot25">
                            A laminar air flow workstation is a closed cabinet fitted with HEPA filtered air flow system
                            with unidirectional constant flow of air with almost no or minimal turbulence.
                            The air flow velocity remains between 0.4 m/s to 0.6 m/s.
                            The purpose of using such workstations in laboratory is to create particle and bacteria
                            free working environment to carry out specialized work. As this unit’s discharge air
                            towards user, they provide no personal protection but product protection from room contaminants.
                        </p>
                        <h4 style={{ textDecoration: "underline" }}>Safe Freezing with a Blast Chillers:</h4>
                        <p className='mbot25'>

                            Aside from the integrity, quality, and taste of the food, blast freezing also offers
                            a health and safety benefit in that frigid temperatures slow down bacteria’s growth.
                            Contamination is significantly reduced if the food is handled safely and then put
                            into the freezer immediately after preparation.
                            This benefit to food safety is one of the reasons why blast freezing is
                            very popular in commercial food preparation areas, as it greatly reduces the risk to customers and consumers.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BlastFreezer
